import script from "./CaliforniaConsumerPrivacyAct.vue?vue&type=script&setup=true&lang=ts"
export * from "./CaliforniaConsumerPrivacyAct.vue?vue&type=script&setup=true&lang=ts"

import "./CaliforniaConsumerPrivacyAct.vue?vue&type=style&index=0&id=7432dde7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7432dde7"]])

export default __exports__